// extracted by mini-css-extract-plugin
export default {"container":"index_container__qFohs","title":"index_title__kYK+J","main":"index_main__r8YUU","button":"index_button__Fj+kX"};